import { render, staticRenderFns } from "./changeTheme2.vue?vue&type=template&id=06e81f3c&"
import script from "./changeTheme2.vue?vue&type=script&lang=js&"
export * from "./changeTheme2.vue?vue&type=script&lang=js&"
import style0 from "./changeTheme2.vue?vue&type=style&index=0&id=06e81f3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports